import React from 'react'

import {noop} from 'es-toolkit'

import InputField from '../input-field'

type InputFieldProps = React.ComponentProps<typeof InputField>

type Props = InputFieldProps & {
  allowDecimals?: boolean
  allowOnly2Decimals?: boolean
}

const sanitizeIntegerInput = (val: string) =>
  val
    .replace(/[^\d-]/g, '') // allow only digits and negative signs
    .replace(/(?!^)-/g, '') // allow negative sign only at beginning
    .replace(/^0+(.)/, '$1') // strip zero digits from the beginning

const sanitizeDecimalInput = (val: string, allowOnly2Decimals = false) => {
  const result = val
    .replace(/[^\d-.]/g, '') // allow only digits, negative signs and decimal separators
    .replace(/(?!^)-/g, '') // allow negative sign only at beginning
    .replace(/(?=^)\./g, '') // allow dot never at beginning
    .replace(/^0+(\d)/, '$1') // strip zero digits from the beginning (before digits)
    .replace(/\.(\d+)(\.)/, '$1.') // do not allow multiple decimal separators

  if (allowOnly2Decimals) {
    return result.replace(/^(-?\d+\.\d{0,2})\d*$/, '$1') // do not allow more than 2 decimals
  }
  return result
}

const NumberInputField = ({
  onChange = noop,
  allowDecimals = false,
  allowOnly2Decimals = false,
  ...props
}: Props) => {
  const handleChange: InputFieldProps['onChange'] = (value, name, event) =>
    onChange(
      allowDecimals ? sanitizeDecimalInput(value, allowOnly2Decimals) : sanitizeIntegerInput(value),
      name,
      event
    )

  return <InputField {...props} onChange={handleChange} />
}

export default NumberInputField
